import React, { useEffect } from "react";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function DriverDrinkingHabit() {
  const [DriverHabit, SetDriverHabit] = useState([]);
  const [SelectedStatus, SetSelectedStatus] = useState([]);

  const InitState = {
    Status: null,
    StatusRef: null,
  };
  const [Details, setDetails] = useState(InitState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const pattern = /[^a-zA-Z ]/g;
    let result = pattern.test(value);
    if (result) {
      setDetails({
        ...Details,
        [name]: value.replace(pattern, "").toUpperCase(),
      });
    } else {
      setDetails({
        ...Details,
        [name]: value.toUpperCase(),
      });
    }
  };
  const SuccessMSG = (msg) => {
    //console.log(msg)
    toast.success(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };
  const WarningMSG = (msg) => {
    //console.log(msg)
    toast.warning(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };
  const FailedMSG = (msg) => {
    //console.log(msg)
    toast.error(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };

  const handleUpdate = (e) => {
    const { name, value } = e.target;
    const pattern = /[^a-zA-Z ]/g;
    let result = pattern.test(value);
    if (result) {
      SetSelectedStatus({
        ...SelectedStatus,
        [name]: value.replace(pattern, "").toUpperCase(),
      });
    } else {
      SetSelectedStatus({
        ...SelectedStatus,
        [name]: value.toUpperCase(),
      });
    }
  };

  const handleEdit = (items) => {
    const InitStateEdit = {
      Id: items.Id,
      Status: items.Status,
      StatusRef: items.Status_Ref,
    };
    SetSelectedStatus(InitStateEdit);
    //console.log(InitStateEdit);
  };

  const fetchDriverHabit = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/statusTypeSub/FetchStatusTypeSubByStatusName/Driver_Drinking_Habit`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
          },
        },
        { withCredentials: true }
      );
      //console.log("Fetched data:", response.data);// Log the fetched data
      SetDriverHabit(response.data);
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
  };

  useEffect(() => {
    fetchDriverHabit();
  }, []);

  const UpdateForm = async (event) => {
    event.preventDefault();
    try {
      await axios
        .put(
          `${process.env.REACT_APP_API_BASE_URL}/statusTypeSub/UpdateStatusTypeSub/Driver_Drinking_Habit`,
          SelectedStatus,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
            },
          }
        )
        .then((res) => {
          SuccessMSG(res.data.message);
          SetSelectedStatus([]);
          fetchDriverHabit();
        })
        .catch((err) => {
          if (err.response && err.response.status !== 200)
            FailedMSG("Something went Wrong");
        });
      event.target.reset();
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
  };

  const handleDelete = (items) => {
    try {
      axios
        .post(
          `${process.env.REACT_APP_API_BASE_URL}/statusType/DeleteDriverHabit`,
          items,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem(
                "access_token"
              )}`,
            },
          }
        )
        .then((res) => {
          SuccessMSG(res.data.message);
          fetchDriverHabit();
        })
        .catch((err) => {
          if (err.response && err.response.status !== 200)
            FailedMSG("Something went Wrong");
        });
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    //console.log(Details);
    try {
      await axios
        .post(
          `${process.env.REACT_APP_API_BASE_URL}/statusTypeSub/AddStatusTypeSub/Driver_Drinking_Habit`,
          Details,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
            },
          }
        )
        .then((res) => {
          if (res.status === 200) {
            SuccessMSG(res.data.message);
          }
          if (res.status === 201) {
            WarningMSG(res.data.message);
          }
          setDetails([]);
          fetchDriverHabit();
        })
        .catch((err) => {
          if (err.response && err.response.status !== 200)
            FailedMSG("Something went Wrong");
        });
      event.target.reset();
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
  };

  return (
    <>
      <ToastContainer />
      <div className="MSContainer">
        <div className="MSContainerChild">
          <p className="MSCHead">Driver Drinking Habit</p>
          <form
            className="MSForm"
            onSubmit={SelectedStatus.Id ? UpdateForm : handleSubmit}
          >
            <div className="MSFormInputs">
              <input
                className="MSFormInput1"
                type="text"
                required
                value={
                  SelectedStatus.Status ? SelectedStatus.Status : Details.Status
                }
                onChange={SelectedStatus.Id ? null : handleChange}
                name="Status"
                placeholder="Enter Habit"
              ></input>
              <input
                className="MSFormInput1"
                type="text"
                required
                value={
                  SelectedStatus.StatusRef
                    ? SelectedStatus.StatusRef
                    : Details.StatusRef
                }
                onChange={SelectedStatus.Id ? handleUpdate : handleChange}
                name="StatusRef"
                placeholder="Ref Habit"
              ></input>
            </div>
            <button className="MSFormSubmitBtn" type="submit">
              Save
            </button>
          </form>
        </div>
        <div className="MSContainerChild1">
          <div className="MSCTHeads">
            <p className="MSCTHLabels">Habit</p>
            <p className="MSCTHLabels">Ref Habit</p>
            <div className="MSCTBtns"></div>
          </div>
          {DriverHabit.length < 1 ? (
            <p> No Status Found</p>
          ) : (
            DriverHabit.map((items) => {
              return (
                <div className="MSCTiles">
                  <p className="MSCTLabels">{items.Status}</p>
                  <p className="MSCTLabels">{items.Status_Ref}</p>
                  <div className="MSCTBtns">
                    <FontAwesomeIcon
                      className="MSCTEditIcon"
                      title="Edit"
                      onClick={() => handleEdit(items)}
                      icon={faEdit}
                    ></FontAwesomeIcon>
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>
    </>
  );
}
